import { z } from 'zod';
import { request } from './client';
import {
  OrderResponseSchema,
  type CreateOrderRequest,
  type OrderResponse,
} from './schemas';

export function createOrder(
  body: CreateOrderRequest,
  idempotencyKey: string,
  signal?: AbortSignal,
): Promise<OrderResponse> {
  return request('/kiosk/v1/orders', OrderResponseSchema, {
    method: 'POST',
    body,
    idempotencyKey,
    signal,
  });
}

export function confirmOrder(
  orderId: string,
  idempotencyKey: string,
  signal?: AbortSignal,
): Promise<OrderResponse> {
  return request(`/kiosk/v1/orders/${orderId}/confirm`, OrderResponseSchema, {
    method: 'POST',
    idempotencyKey,
    signal,
  });
}

export function getOrder(orderId: string, signal?: AbortSignal): Promise<OrderResponse> {
  return request(`/kiosk/v1/orders/${orderId}`, OrderResponseSchema, { signal });
}

export async function cancelOrder(orderId: string, signal?: AbortSignal): Promise<void> {
  await request(`/kiosk/v1/orders/${orderId}`, z.unknown(), { method: 'DELETE', signal });
}
